<template>
  <div>
    <section class="favourite-list">
      <div class="container narrow">
        <intro-text :text="'Your <em>Favourites</em>'" :sub-text="'All the items you’ve saved.'"/>
        <div v-if="this.$root.basket && this.$root.basket.products.length > 0" class="products">
          <template v-for="(basketProduct, index) in this.$root.basket.products">
            <div v-bind:key="index" class="product row align-items-center"
                 data-aos="fade-in">
              <div class="col-auto mr-xl-5">
                <img v-if="basketProduct.product.images.length > 0" v-bind:src="basketProduct.product.images[0].url"
                     class="img-fluid"
                     :alt="'Image: ' + basketProduct.product.title"/>
              </div>
              <div class="col">
                <h3>{{ basketProduct.product.title }}</h3>
                <!--<p>{{ basketProduct.product.description }}</p>-->
                <span class="favourite active" v-on:click="removeProductFromBasket($event, basketProduct.product.id)">
                  Remove from favourites
                </span>
              </div>
            </div>
          </template>
          <div class="text-lg-right">
            <p class="lead">Find these Vintriguing? get in touch for more info</p>
            <a v-bind:href="'mailto:' + this.$root.store.contact_email + '?subject=I find these products Vintriguing, let me know more&body=' + this.messageBody()" class="btn btn-dark mr-1">Email our team</a>
            <a v-bind:href="'tel:' + this.$root.store.telephone_number" class="btn btn-outline-dark">Give us a call</a>
          </div>
        </div>
        <div v-else class="products">
          <p class="lead" data-aos="fade-in">No products have been saved</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import IntroText from "./IntroText";

  IntroText
  export default {
    name: 'FavouriteList',
    components: {
      IntroText
    },
    methods: {
      removeProductFromBasket: function ($event, productId) {
        this.$root.$api.removeProductFromBasket(this.$root.getBasketKey(), productId)
          .then(response => {
            if (response.data != null) {
              this.$root.setBasket(response.data.basket);
            }
          }).catch(error => {
          console.log(error);
        })
      },
      messageBody: function () {
        let message = '';
        if (this.$root.basket && this.$root.basket.products.length) {
          this.$root.basket.products.map(product => {
            message += 'Title: ' + encodeURIComponent(product.product.title) + '%0D%0A';
            message += 'Code: ' + product.product.code + '%0D%0A%0D%0A';
          })
        }
        return message;
      }
    }
  }
</script>
